import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/funzionalita/ricerca-legale-ai")({
  head: () => seoMeta({
    title: "Ricerca legale AI: come funziona e perché conviene",
    description: "Interroga normativa e giurisprudenza italiana ed europea in linguaggio naturale. Risposte strutturate con citazioni verificabili.",
    path: "/funzionalita/ricerca-legale-ai",
  }),
  component: () => (
    <ContentPage
      eyebrow="Funzionalità"
      title="Ricerca legale AI per professionisti italiani"
      lead="La ricerca legale AI di LexAIPro permette di interrogare codici, leggi, sentenze e dottrina in italiano naturale, ottenendo risposte sintetiche con fonti verificabili in pochi secondi."
      tldr="Domanda in italiano → risposta strutturata + citazioni a Cassazione, Gazzetta Ufficiale, Eur-Lex e dottrina, con grado di affidabilità segnalato."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Funzionalità",path:"/funzionalita/ricerca-legale-ai"},{name:"Ricerca legale AI",path:"/funzionalita/ricerca-legale-ai"}]}
      sections={[
        { heading: "Cos'è la ricerca legale AI", body: "È un sistema di retrieval-augmented generation specializzato sul corpus normativo italiano ed europeo: l'AI individua le fonti rilevanti, le verifica e produce una sintesi citabile. Non è un chatbot generalista, è uno strumento progettato per il rigore richiesto dalla pratica legale." },
        { heading: "Cosa puoi chiedere", bullets: [
          "Domande di diritto sostanziale (es. \"Quali sono i requisiti del licenziamento per giusta causa?\")",
          "Ricerche giurisprudenziali (es. \"Sentenze recenti su clausola penale eccessiva\")",
          "Confronto fra norme (es. \"Differenze tra art. 2086 e 2381 c.c.\")",
          "Aggiornamenti normativi (es. \"Cosa cambia con il D.Lgs. 36/2023?\")",
        ] },
        { heading: "Come funziona, passo per passo", bullets: [
          "Scrivi la domanda in linguaggio naturale.",
          "Il motore identifica le fonti pertinenti nel database normativo.",
          "L'AI redige una risposta sintetica e cita ogni passaggio.",
          "Puoi aprire le fonti, esportare la ricerca o salvarla nella pratica.",
        ] },
        { heading: "Affidabilità e citazioni", body: "Ogni risposta riporta articoli, sentenze e fonti consultabili. Per aree in evoluzione viene segnalata esplicitamente la necessità di verifica aggiornata. La responsabilità professionale resta dell'avvocato: LexAIPro fornisce un primo livello di analisi, non un parere." },
      ]}
      faq={[
        { q: "Le fonti sono italiane?", a: "Sì. Il motore copre la legislazione nazionale (codici, leggi, decreti), la giurisprudenza di legittimità e di merito e la normativa europea." },
        { q: "Posso usarla in udienza?", a: "Puoi usarla per preparare l'argomentazione. La citazione finale va sempre verificata sulle fonti ufficiali." },
        { q: "Quanto costa?", a: "Inclusa in tutti i piani LexAIPro a partire da 79 €/mese." },
      ]}
      cta={{ label: "Prova la ricerca AI", to: "/signup" }}
      heroImage={pickContent(45)}
      updated="2026"
    />
  ),
});
